import { GetApi } from './api';

export const PeptideApi = {
  // Get peptide dashboard statistics
  getPeptideDashboardStats: () => GetApi('admin/v1/peptide/dashboard-stats', true),
  getPauseCareDashboardStats: () => GetApi('admin/v1/pausecare/dashboard-stats', true),

  // Get peptide dashboard statistics
  getCompanyPeptideDashboardStats: () => GetApi('company/v1/peptide/dashboard-stats', true),
  getCompanyPauseCareDashboardStats: () => GetApi('company/v1/pausecare/dashboard-stats', true),

  // Get peptide user activity
  getPeptideUserActivity: () => GetApi('admin/v1/peptide/user-activity', true)
};
